import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);

export function carousel() {
  const carousel = document.querySelectorAll('.js-carousel');
  if(carousel.length) {
    for (let i = 0; i < carousel.length; i++) {
      const el = carousel[i];
      //const slideLength = el.querySelectorAll('.swiper-slide').length;
      new Swiper(el, {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        slidesPerView: 'auto',
        spaceBetween: 0,
        edgeSwipeThreshold: 100,
        grabCursor: true
      });
    }
  }
}